// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__110QH","title":"FrontImage_title__5D0Uc"};